<template>
  <div class="content">
    <m-header><div slot="nav"></div></m-header>
    <div class="container">
      <div class="row">
        <div class="wanl-entry">
          <div class="head" style="margin: 0 auto 20px;">
            <div class="title">
              <p>诊所/工厂认证申请</p>
            </div>
            <div class="entry-content">
              <ol class="ui-step ui-step-4">
                <li class="step-start step-done">
                  <div class="ui-step-line"></div>
                  <div class="ui-step-cont">
                    <span class="ui-step-cont-number">1</span>
                    <span class="ui-step-cont-text">注册账号</span>
                  </div>
                </li>
                <li class="step-active">
                  <div class="ui-step-line"></div>
                  <div class="ui-step-cont">
                    <span class="ui-step-cont-number">2</span>
                    <span class="ui-step-cont-text">资质信息</span>
                  </div>
                </li>
                <li class="step-end">
                  <div class="ui-step-line"></div>
                  <div class="ui-step-cont">
                    <span class="ui-step-cont-number">3</span>
                    <span class="ui-step-cont-text">提交审核</span>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div class="title-container"><span class="title">主体资质认证</span></div>
          <div style="text-align: center; padding-top: 15px; padding-bottom: 15px;">
            <p style="font-size: 32px;">
              欢迎加入医小智
            </p>
            <p style="font-size: 15px; padding-top: 10px;font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif">
              感谢您的信任和选择医小智互联网医疗服务平台，医小智将为您提供时效专业的CAD设计服务，<br>
			  互通医生与技师，医生与患者的无障碍一对一的有效对话，医生好看诊，技师好服务，患者好看牙。
            </p>
          </div>
          <div class="form">
            <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" size="medium " class="demo-ruleForm">
              <el-form-item label="工厂/诊所名称:" prop="factoryName">
                <el-input v-model="ruleForm.factoryName"></el-input>
              </el-form-item>
			  <el-form-item label="所属地:" prop="location">
			  	<Map @selMap="selMap" v-if="ruleForm.location!='手动输入'"></Map>
          <el-input v-model="address" v-else/>
			  </el-form-item>
              <el-form-item label="服务类型选择:" prop="service">
                <el-select v-model="ruleForm.service" placeholder="请选择服务类型">
                  <el-option label="口腔诊所" value="10"></el-option>
                  <el-option label="口腔医院" value="11"></el-option>
                  <el-option label="义齿加工所" value="00"></el-option>
                  <!-- <el-option label="其他" value="99"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="营业执照上传:" prop="certificate">
                <el-upload class="upload-demo"
                  action
                  :before-upload="beforeUpload"
                  :http-request="uploadFile"
                  :data="{objectType:'06',objectTag:''}"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :auto-upload="true"
                  :limit="5"
                  :list-type="pdfFile"
                  multiple>
                  <el-button slot="trigger" size="small" type="warning">点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="联系人姓名:" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="联系方式:" prop="mobile">
                <el-input v-model="ruleForm.mobile" maxlength="11" disabled show-word-limit placeholder="请输入联系人手机号"></el-input>
              </el-form-item>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
              <el-form-item>
                <el-checkbox class="agree" v-model="isAgree">
                  我已阅读并同意遵守
                  <a @click.prevent="openAgree('00')">用户注册准则</a> 和
                  <a @click.prevent="openAgree('03')">医小智准则条款</a>
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="submitForm('ruleForm')">立即申请</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogContentVisible" :center="true" width="60%" top="8vh" >
        <div class="dialog-content">
          <div v-html="dialogContent"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeAgree()">我已阅读</el-button>
        </span>
      </el-dialog>
    </div>
  <m-footer></m-footer>
  </div>
</template>
<script>
   import MHeader from '/common/MHeader'
   import MFooter from '/common/MFooter'
   import {mapState } from 'vuex'
   import Map from '../../components/map'
   import {
     uploadByPieces
   } from "../../../common/upload.js";
   import {
     setStore,
     getStore,
     removeStore
   } from '/utils/storage.js'
   export default {
      data() {
        const validateImage = (rule, value, callback) => {
          if (!this.checkImgSuccess) {
            callback(new Error('请先上传图片'))
          } else {
            callback()
          }
        }
        //地区校验
        // var validateLocation = function (rule,value,callback) {
        //     if(value === ''){
        //       callback(new Error('所属地区不能为空'))
        //     }else {
        //      callback()
        //    }
        // }
        return {
          pdfFile:'picture',
          checkImgSuccess: false,
          dialogImageUrl: "",
          dialogVisible: false,
          dialogContentVisible: false,
          dialogTitle: '',
          dialogContent: '',
          isAgree: false,
          token: '',
          certList:[],
          formData: "",
          address: '',
          ruleForm: {
            factoryName: '',
            service: '',
            name: '',
            location:'',
            mobile:'',
          },
          rules: {
            factoryName: [
              { required: true, message: '请输入诊所/工厂名称', trigger: 'blur' }
            ],
            // location: [{
            //   required: true,
            //   validator: validateLocation,
            //   trigger: 'blur'
            // }],
            certificate: [
              {required: true, validator: validateImage, trigger: 'change'},
            ],
            service: [
              { required: true, message: '请选择服务范围', trigger: 'change' }
            ],
            name: [
              { required: true, message: '请输入联系人名称', trigger: 'blur' }
            ]
          }
        };
      },
      components: {
        MHeader,
        MFooter,
        Map
      },
      computed: {
        ...mapState(['user'])
      },
      mounted() {
        this.$yxz.title("医小智 - 诊所/工厂认证申请")
        this.token = getStore('token')
        this.ruleForm.mobile = this.user.loginName;
      },
      methods: {
        async uploadFile({response,file,data}) {
          var loading = this.$loading({text: '等待上传完成，已上传 0%'});
          var that = this
          uploadByPieces({
            file: file, // 文件
            data: data,
            pieceSize: 3, // 分片大小
            concurrent: 3,
          process: res => {
            loading.setText('等待上传完成，已上传'+res+'%')
            console.log('分片上传 -> process', res)
            if (res == 100) {
              loading.close();
            }
          },
            success: res => {
              if(data.objectType=='06' && data.objectTag=='') {
                this.checkImgSuccess = true
                this.$refs.ruleForm.clearValidate('certificate')
                this.certList.push(res.data.url)
              }
              loading.close();
              // console.log('分片上传 -> success', res)
            },
            error: e => {
              // console.log('分片上传 -> error', e)
            }
          })
        },
        submitForm(formName) {
          if (!this.isAgree) {
            this.$yxz.msg('请阅读并同意相关注册协议')
            return false
          }
          let that = this;
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let formData = new FormData();
              for (var key in that.ruleForm) {
                formData.append(key, that.ruleForm[key]);
              }
              that.formData = formData;
               this.addForm();
              // this.$refs.ruleForm.resetFields()//清除表单信息
              // this.$refs.upload.clearFiles()//清空上传列表
              // this.fileList = []//集合清空
            } else {
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.ruleForm.file = "";
          this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
          this.checkImgSuccess = false
          // for (let i = 0; i < this.certList.file.length; i++) {
          //   if (file === this.ruleForm.file[i]) {
          //     this.ruleForm.file.splice(i, 1);
          //   }
          // }
        },
        handlePreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        handleExceed() {
          this.$message({ type: 'error', message: '最多支持5个图片上传' })
        },
        // 上传前处理
        beforeUpload(file) {
          let fileSize = file.size
          const FIVE_M= 20*1024*1024;
          //大于5M，不允许上传
          if(fileSize>FIVE_M){
            this.$message.error("最大上传20M")
            return false
          }
          //判断文件类型
          let fileName = file.name
          let reg = /^.+\.(pdf|jpeg|png|jpg)$/
          let pdf = /^.+\.(pdf)$/
          this.pdfFile = pdf.test(fileName)?'text':'picture'
          if(!reg.test(fileName)){
            this.$message.error("只能上传pdf|jpeg|png|jpg!")
            return false
          }
          return true
        },
        //添加
        addForm() {
          this.$api.post({
            url: '/user/dem-auth',
            data: {
              nickName: this.formData.get('factoryName'),
              contact: this.formData.get('name'),
              mobile:this.formData.get('mobile'),
              mail: '',
              cert: this.certList.join(','),
              demServType: this.formData.get('service'),
              location: this.ruleForm.location=='手动输入'?this.address:this.ruleForm.location
            }
          }).then(res => {
            if (res.code == 200) {
              this.$yxz.msg('申请成功，请等待审核结果','success')
              this.$router.push({
                path: "/"
              });
            } else {
              this.$yxz.msg(res.msg);
            }
          })
        },
        openAgree(agreeType) {
          this.$api.get({
            url: '/biz/agree/' + agreeType,
            isToken: false
          }).then(res=>{
            if (res.code === 200) {
              this.dialogContent = this.$yxz.showHtml(res.data.agreeContent) || '';
              this.dialogTitle = res.data.agreeTitle || ''
              this.dialogContentVisible = true;
            }
          })
        },
        closeAgree() {
          this.dialogTitle = '';
          this.dialogContent = '';
          this.dialogContentVisible = false;
        },
        selMap(provinceValue,cityValue,RegionValue){
          this.ruleForm.location = provinceValue + cityValue + RegionValue
        }
      }
    }
</script>

<style lang="scss" scoped>
  .content {
      width: 100%;
      overflow: auto;
  }
  .container {
    width: 60%;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 20px;
  }
  .row {
      margin-left: -15px;
      margin-right: -15px;
  }
  .wanl-entry>div {
      position: relative;
      background: #fff;
      width: 100%;
      // margin: 0 auto 20px;
  }
  .wanl-entry .head .title {
      text-align: center;
      margin: 0;
      color: #666;
      padding: 15px;
      border-bottom: 1px dashed #e0e0e0;
  }
  .wanl-entry .entry-content {
      padding: 20px;
  }
  [v-cloak] {
    display: none;
  }

  .content {
    background: #f5f5f5;
    overflow: hidden;
  }

  .btn-lg,
  .btn-group-lg>.btn {
    height: 38px;
    line-height: 1.2;
  }

  .wanl-entry .head .title {
    text-align: center;
    margin: 0;
    color: #666;
    padding: 15px;
    border-bottom: 1px dashed #e0e0e0;
  }

  .wanl-entry .head .title p {
    font-size: 16px;
    font-weight: 700;
    color: #555;
    margin: 0;
    line-height: 24px;
  }

  .wanl-entry .title-container {
    padding: 10px 0 10px 15px;
    font-size: 15px;
    border-bottom: 1px dashed #ececec;
  }

  .wanl-entry .title-container .title {
    border-left: 4px solid #e74c3c !important;
    padding-left: 10px;
  }

  .wanl-entry .entry-content {
    padding: 20px;
  }

  .wanl-entry .info {
    padding: 20px 50px;
    text-align: center;
  }

  ol {
    list-style: none outside none;
    margin: 0;
    padding: 0;
  }

  .ui-step {
    color: #b7b7b7;
    padding: 0 60px;
    margin-bottom: 35px;
    position: relative;
  }

  .ui-step:after {
    display: block;
    content: "";
    height: 0;
    font-size: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }

  .ui-step li {
    float: left;
    position: relative;
  }

  .ui-step .step-end {
    width: 120px;
    position: absolute;
    top: 0;
    right: -60px;
  }

  .ui-step-line {
    height: 5px;
    background-color: #e0e0e0;
    margin-top: 20px;
  }

  .step-end .ui-step-line {
    display: none;
  }

  .ui-step-cont {
    width: 120px;
    position: absolute;
    top: 0;
    left: -15px;
    text-align: center;
  }

  .ui-step-cont-number {
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    line-height: 35px;
    color: #fff;
    border-radius: 50%;
    border: 2px solid #fff;
    font-size: 16px;
    background-color: #d8d8d8;
  }

  .ui-step-cont-text {
    position: relative;
    top: 45px;
    left: -42px;
    font-size: 12px;
  }

  .ui-step-4 li {
    width: 50%;
  }

  .step-done .ui-step-cont-number {
    background-color: #18bc9c;
  }

  .step-done .ui-step-cont-text {
    color: #18bc9c;
  }

  .step-done .ui-step-line {
    background-color: #18bc9c;
  }

  /* Active */
  .step-active .ui-step-cont-number {
    background-color: #18bc9c;
  }

  .step-active .ui-step-cont-text {
    color: #18bc9c;
    font-weight: bold;
  }

  .step-active .ui-step-line {
    background-color: #e0e0e0;
  }
  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    margin-bottom: 20px;
  }
  .dialog-content {
    height: 55vh;
    overflow: auto;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// factoryAuth.vue?1f53fe66